'use client'

import EventCardImageTitle from '@/components/_cards/event/driver-calendar/event-card-image-title'
import ImageWithFallback from '@/components/common/image-with-fallback'
import { localDateTime } from '@/helpers/datetime'
import { getMainSession } from '@/helpers/events'
import { getUserProfilePictureUrl } from '@/helpers/user'
import EventCardStartTime from './event-card-start-time'

export default function EventCardFuture({ nextEvent, games, user }) {
  let nextEventMainSession = null
  let nextEventGame = null
  let nextEventStart = null

  if (nextEvent?.sessions) {
    nextEventMainSession = getMainSession({ event: nextEvent })
    const track = nextEventMainSession?.track
    if (track) {
      nextEventGame = games.find((s) => s.name === track.gameName)
    }

    nextEventStart = localDateTime({
      datetime: nextEventMainSession?.targetDateTime,
      timezone: nextEventMainSession?.targetTimezone,
      format: false,
    })
  }

  return (
    <>
      {nextEvent && nextEvent.sessions ? (
        <div>
          <div className="flex items-center">
            <div className="mr-4 w-fit">
              <div className="relative flex h-11 w-11 overflow-hidden rounded-full">
                <ImageWithFallback
                  alt="Profile pic"
                  src={getUserProfilePictureUrl(user, {
                    profile: 'driver',
                  })}
                  fallbackUrl="/img/default/profile-pic.webp"
                  fill
                />
              </div>
            </div>

            <div className="font-inter text-p-2">
              <span className="text font-semibold">{user.username}</span>
              <span className="text-neutral-blue-300"> is attending the</span>
              <span className="font-semibold"> {nextEvent.name}</span>
              {nextEventGame && (
                <>
                  <span className="text-neutral-blue-300"> on </span>
                  <span className="font-semibold text-white">
                    {nextEventGame.nicename}
                  </span>
                </>
              )}
              {nextEventMainSession?.targetDateTime &&
              nextEventMainSession?.targetTimezone ? (
                <span className="text-neutral-blue-300">
                  {nextEventStart.format(' dddd DD MMMM ')} at{' '}
                  {nextEventStart.format(' H:mm')} {nextEventStart.format('z')}
                </span>
              ) : null}
              {nextEvent?.league?.name ? (
                <>
                  <span className="text-neutral-blue-300"> hosted by </span>
                  <span className="font-semibold text-white">
                    {nextEvent.league.name}
                  </span>
                </>
              ) : null}
            </div>
          </div>

          <div className="mt-4 rounded-md border border-neutral-blue-700 bg-neutral-blue-900 font-inter">
            <div className="flex w-full flex-col p-4 desktop-sm:justify-between desktop-lg:flex-row">
              <EventCardImageTitle
                event={nextEvent}
                eventMainSession={nextEventMainSession}
              />

              <EventCardStartTime timeIn={nextEventStart} />
            </div>
          </div>
        </div>
      ) : null}
    </>
  )
}
